module.exports = __webpack_public_path__ + "img/pdf_bg_red.21b36759.png";